import React, { Component, useCallback, useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone'
import SingleFileUpload from './SingleFileUpload';

const thumbsContainer = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 16
};

const thumb = {
    display: 'inline-flex',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    marginBottom: 8,
    marginRight: 8,
    width: 100,
    height: 100,
    padding: 4,
    boxSizing: 'border-box'
};

const thumbInner = {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden',
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
};

const img = {
    display: 'block',
    width: 'auto',
    height: '100%'
};


export default function Swatches({ companyCode, company }) {

    const [files, setFiles] = useState([]);
    const { getRootProps, getInputProps } = useDropzone({
        accept: {
            'image/*': []
        },
        onDrop: acceptedFiles => {
            const newFiles = acceptedFiles.map(file => Object.assign(file, {
                preview: URL.createObjectURL(file)
            }));
            setFiles([...files, ...newFiles]);
        }
    });

    const handleUpload = () => {
        // write a code to fetch s3 put url , then upload file to s3 and then call db to create entry in db
        console.log(files);


    }

    useEffect(() => {
        // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
        return () => files.forEach(file => URL.revokeObjectURL(file.preview));
    }, []);

    return (
        <section className="container">
            <div {...getRootProps({ className: 'dropzone' })} style={{
                border: "2px dashed black",
                borderRadius: "5px",
                height: "200px",
                width: "100%",
                padding: "20px",
                textAlign: "center",
                justifyContent: "center",
            }}>
                <h1>{`Add Swatch For ${companyCode}`}</h1>
                <input {...getInputProps()} />
                <p>Drag 'n' drop some files here, or click to select files</p>
            </div>
            <aside style={thumbsContainer}>
                {/* {thumbs}
                 */}
                {
                    files.map((file) => {
                        return <SingleFileUpload file={file} companyCode={companyCode} company={company} />
                    })
                }
            </aside>
        </section>
    );
}
